import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { deactivateSetting } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetDeactivate(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: {
            id: string | undefined
            poolShip: number | undefined
        }) => {
            return deactivateSetting(payload)
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_deactivated', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch()
            toast.success('با موفقیت انجام شد')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'deactivate',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
